export const errors = {
  noEditorExist: 'Edytor nie istnieje',
  B2BTokenRequestFailed:
    'Błąd podczas próby pobrania zasobów partnera. Skontaktuj się z administratorem.',
  emailConfirmCodeIncorrect: 'Nieprawidłowy kod potwierdzający z e-maila',
  authenticatorConfirmIncorrect:
    'Nieprawidłowy kod z aplikacji uwierzytelniającej',
  invalidPassword: 'Nieprawidłowe hasło',
  flowCriterionCodeNotUnique: 'Kryterium o tym kodzie już istnieje',
  flowCriterionValueCodeNotUnique:
    'Wartość o tym kodzie już istnieje w tym kryterium',
  notAllFlowCriteriaProvided:
    'Aby zmienić kolejność, należy przekazać wszystkie kryteria',
  notAllFlowCriterionValuesProvided:
    'Aby zmienić kolejność, należy przekazać wszystkie wartości kryterium',
  flowCriterionHasDependents:
    'Wartości innych kryteriów zależą od tego kryterium. Najpierw usuń te zależności',
  flowCriterionValueHasDependents:
    'Inne wartości zależą od tej wartości. Najpierw usuń te zależności',
}
